export const icons = [
  {
    name: "google",
    iconUrl: "/icons/google.svg",
  },
  {
    name: "microsoft",
    iconUrl: "/icons/microsoft.svg",
  },
  {
    name: "facebook",
    iconUrl: "/icons/facebook.svg",
  },
  {
    name: "check_mark",
    iconUrl: "/icons/check_mark.svg",
  },
  { name: "flag", iconUrl: "/icons/flag.svg" },
  { name: "home", iconUrl: "/icons/home.svg" },
  { name: "megaphone", iconUrl: "/icons/megaphone.svg" },
  { name: "survey", iconUrl: "/icons/survey.svg" },
  { name: "tasks", iconUrl: "/icons/tasks.svg" },
  { name: "employee", iconUrl: "/icons/employees.svg" },
  { name: "organization", iconUrl: "/icons/organization.svg" },
  { name: "calendar", iconUrl: "/icons/calendar.svg" },
  { name: "attendance", iconUrl: "/icons/schedule.svg" },
  { name: "timesheets", iconUrl: "/icons/timesheet.svg" },
  { name: "recruits", iconUrl: "/icons/recruits.svg" },
  { name: "report", iconUrl: "/icons/reports.svg" },
  { name: "payroll", iconUrl: "/icons/payroll.svg" },
  { name: "corehr", iconUrl: "/icons/corehr.svg" },
  { name: "configure", iconUrl: "/icons/configure.svg" },
  { name: "subscription", iconUrl: "/icons/subscription.svg" },
  { name: "help", iconUrl: "/icons/help.svg" },
  { name: "drawer", iconUrl: "/icons/drawer.svg" },
  { name: "schedule", iconUrl: "/icons/schedule.svg" },
  { name: "job", iconUrl: "/icons/job.svg" },
  { name: "add_user", iconUrl: "/icons/add_user.svg" },

  { name: "admin_styled", iconUrl: "/icons/custom/admin_user.svg" },
  { name: "employee_styled", iconUrl: "/icons/custom/employee_user.svg" },
  { name: "hr_styled", iconUrl: "/icons/custom/hr_user.svg" },
  { name: "manager_styled", iconUrl: "/icons/custom/manager_user.svg" },

  { name: "contract_og", iconUrl: "/icons/organogram/contract.svg" },
  { name: "expand_og", iconUrl: "/icons/organogram/expand.svg" },
  { name: "department_og", iconUrl: "/icons/organogram/department.svg" },
  { name: "payroll_og", iconUrl: "/icons/organogram/payroll.svg" },
  { name: "position_og", iconUrl: "/icons/organogram/position.svg" },
  { name: "unit_og", iconUrl: "/icons/organogram/unit.svg" },
  { name: "work_pattern_og", iconUrl: "/icons/organogram/work-pattern.svg" },
  { name: "leave_policy_og", iconUrl: "/icons/organogram/leave-policy.svg" },

  { name: "airplane_lt", iconUrl: "/icons/leave-types/airplane.svg" },
  { name: "baby_lt", iconUrl: "/icons/leave-types/baby.svg" },
  { name: "emergency_lt", iconUrl: "/icons/leave-types/emergency.svg" },
  { name: "school_lt", iconUrl: "/icons/leave-types/school.svg" },
  { name: "stethoscope_lt", iconUrl: "/icons/leave-types/stethoscope.svg" },
  { name: "user_lt", iconUrl: "/icons/leave-types/user.svg" },

  { name: "list", iconUrl: "/icons/list.svg" },
  { name: "tile", iconUrl: "/icons/tile.svg" },
  { name: "filter", iconUrl: "/icons/filter.svg" },
  { name: "status", iconUrl: "/icons/status.svg" },
  { name: "role", iconUrl: "/icons/role.svg" },
  { name: "department", iconUrl: "/icons/department.svg" },
  { name: "actions", iconUrl: "/icons/actions.svg" },
  { name: "export", iconUrl: "/icons/export.svg" },
  { name: "add_employee", iconUrl: "/icons/add_employee.svg" },
  { name: "plus_circle", iconUrl: "/icons/plus_circle.svg" },

  { name: "plus_circle", iconUrl: "/icons/plus_circle.svg" },
  { name: "alarm", iconUrl: "/icons/alarm.svg" },
  { name: "seal-check", iconUrl: "/icons/seal-check.svg" },
  { name: "user-circle-dashed", iconUrl: "/icons/user-circle-dashed.svg" },
  { name: "user-circle-check", iconUrl: "/icons/user-circle-check.svg" },
  { name: "user-circle-minus", iconUrl: "/icons/user-circle-minus.svg" },
  { name: "calendar-blank", iconUrl: "/icons/calendar-blank.svg" },
  { name: "calendar-star", iconUrl: "/icons/calendar-star.svg" },
  { name: "sparkle", iconUrl: "/icons/sparkle.svg" },
  { name: "arrow-back-ios-new", iconUrl: "/icons/arrow-back-ios-new.svg" },
  { name: "arrow-forward-ios", iconUrl: "/icons/arrow-forward-ios.svg" },
  { name: "refresh", iconUrl: "/icons/refresh.svg" },
  { name: "info", iconUrl: "/icons/info.svg" },
  { name: "caret-down", iconUrl: "/icons/caret-down.svg" },
  { name: "plus-circle", iconUrl: "/icons/plus-circle.svg" },
  { name: "minus-circle", iconUrl: "/icons/minus-circle.svg" },
  { name: "login", iconUrl: "/icons/login.svg" },
  { name: "message", iconUrl: "/icons/message.svg" },
  { name: "user_minus", iconUrl: "/icons/user_minus.svg" },
  { name: "alarm", iconUrl: "/icons/alarm.svg" },
  { name: "notifications", iconUrl: "/icons/notifications.svg" },
  { name: "file_plus", iconUrl: "/icons/file_plus.svg" },
  {
    name: "dots-three-outline-vertical",
    iconUrl: "/icons/dots-three-outline-vertical.svg",
  },
  { name: "user-circle", iconUrl: "/icons/user-circle.svg" },
  { name: "magnifying-glass", iconUrl: "/icons/magnifying-glass.svg" },
  { name: "location", iconUrl: "/icons/location.svg" },
  { name: "pencil", iconUrl: "/icons/pencil.svg" },
  { name: "hand-raised", iconUrl: "/icons/hand-raised.svg" },
  { name: "hand", iconUrl: "/icons/hand.svg" },

  { name: "target", iconUrl: "/icons/custom/target.svg" },
  { name: "trending_down", iconUrl: "/icons/custom/trending_down.svg" },
  { name: "spinner", iconUrl: "/icons/custom/spinner.svg" },
  { name: "check_circle", iconUrl: "/icons/custom/check_circle.svg" },

  { name: "pulse", iconUrl: "/icons/custom/pulse.svg" },
  { name: "chat", iconUrl: "/icons/custom/chat.svg" },
  { name: "chart_bar", iconUrl: "/icons/custom/chart_bar.svg" },

  {
    name: "circle_plus_filled",
    iconUrl: "/icons/custom/circle_plus_filled.svg",
  },
  { name: "user_gear", iconUrl: "/icons/custom/user_gear.svg" },
  { name: "minus_user", iconUrl: "/icons/custom/minus_user.svg" },
  { name: "add_user_01", iconUrl: "/icons/custom/add_user.svg" },
  { name: "seal_check", iconUrl: "/icons/custom/seal_check.svg" },
  { name: "x-circle", iconUrl: "/icons/x-circle.svg" },
  { name: "share_fat", iconUrl: "/icons/custom/share_fat.svg" },
  { name: "paper_plane_tilt", iconUrl: "/icons/custom/paper_plane_tilt.svg" },
  {
    name: "chat_teardrop_dots",
    iconUrl: "/icons/custom/chat_teardrop_dots.svg",
  },
  { name: "heart", iconUrl: "/icons/custom/heart.svg" },
  { name: "eye", iconUrl: "/icons/custom/eye.svg" },

  { name: "users_three", iconUrl: "/icons/custom/users_three.svg" },
  { name: "file_archive", iconUrl: "/icons/custom/file_archive.svg" },
  { name: "stack", iconUrl: "/icons/custom/stack.svg" },
  { name: "stack-gray", iconUrl: "/icons/custom/stack-gray.svg" },
  { name: "crown", iconUrl: "/icons/custom/crown.svg" },
  { name: "frame", iconUrl: "/icons/custom/frame.svg" },
  { name: "performance", iconUrl: "/icons/performance.svg" },
  { name: "training", iconUrl: "/icons/training.svg" },
  { name: "documents", iconUrl: "/icons/document.svg" },

  { name: "attendance_absent", iconUrl: "/icons/attendance/absent-days.svg" },
  { name: "attendance_present", iconUrl: "/icons/attendance/present-days.svg" },
  { name: "attendance_working", iconUrl: "/icons/attendance/working-days.svg" },

  { name: "payroll-car", iconUrl: "/icons/payroll/payroll-car.svg" },
  { name: "payroll-van", iconUrl: "/icons/payroll/payroll-van.svg" },

  // employee types
  { name: "employee_remote", iconUrl: "/icons/employee/remote.svg" },
  { name: "employee_full_time", iconUrl: "/icons/employee/full-time.svg" },
  { name: "employee_part_time", iconUrl: "/icons/employee/part-time.svg" },

  // payroll
  { name: "chart-bar", iconUrl: "/icons/payroll/chart-bar.svg" },
  { name: "trend-up", iconUrl: "/icons/payroll/trend-up.svg" },
  { name: "users", iconUrl: "/icons/payroll/users.svg" },
  { name: "wallet", iconUrl: "/icons/payroll/wallet.svg" },
  { name: "payroll-warning", iconUrl: "/icons/payroll/payroll-warning.svg" },
  { name: "payroll-count-clock-down", iconUrl: "/icons/payroll/count-clock-down.svg" },
  { name: "payroll-currency-eur", iconUrl: "/icons/payroll/currency-eur.svg" },
  { name: "payroll-flip-vertical", iconUrl: "/icons/payroll/flip-vertical.svg" },
  { name: "payroll-timer", iconUrl: "/icons/payroll/timer.svg" },
  { name: "payroll-trend-down", iconUrl: "/icons/payroll/trend-down.svg" },
  { name: "payroll-seal-check", iconUrl: "/icons/payroll/payroll-seal-check.svg" },
  { name: "payroll-check-circle", iconUrl: "/icons/payroll/payroll-check-circle.svg" },
  { name: "payroll-trend-down", iconUrl: "/icons/payroll/payroll-trend-down.svg" },
  { name: "payroll-plus-circle", iconUrl: "/icons/payroll/payroll-plus-circle.svg" },
  { name: "payroll-pencil-simple-line", iconUrl: "/icons/payroll/payroll-pencil-simple-line.svg" },
  { name: "payroll-seal-warning", iconUrl: "/icons/payroll/payroll-seal-warning.svg" },
  { name: "payroll-calendar-plus", iconUrl: "/icons/payroll/payroll-calendar-plus.svg" },
  { name: "payroll-info", iconUrl: "/icons/payroll/payroll-info.svg" },
  { name: "payroll-done-ring-round-light", iconUrl: "/icons/payroll/payroll-done-ring-round-light.svg" },
  { name: "payroll-frame", iconUrl: "/icons/payroll/payroll-frame.svg" },
  { name: "payroll-file-text", iconUrl: "/icons/payroll/payroll-file-text.svg" },
  { name: "payroll-file", iconUrl: "/icons/payroll/payroll-file.svg" },
  { name: "payroll-download-simple", iconUrl: "/icons/payroll/payroll-download-simple.svg" },
  { name: "payroll-users-three", iconUrl: "/icons/payroll/payroll-users-three.svg" },
  { name: "payslip-check-circle", iconUrl: "/icons/payroll/payslip-check-circle.svg" },
  { name: "payroll-paper-plane-tilt", iconUrl: "/icons/payroll/payroll-paper-plane-tilt.svg" },
  { name: "payroll-envelope-simple", iconUrl: "/icons/payroll/payroll-envelope-simple.svg" },
  { name: "payroll-ambulance", iconUrl: "/icons/payroll/payroll-ambulance.svg" },
  { name: "payroll-tooth", iconUrl: "/icons/payroll/payroll-tooth.svg" },
  { name: "payroll-heart-beat", iconUrl: "/icons/payroll/payroll-heart-beat.svg" },
  { name: "payroll-flower-tulip", iconUrl: "/icons/payroll/payroll-flower-tulip.svg" },
  { name: "payroll-chart-line", iconUrl: "/icons/payroll/payroll-chart-line.svg" },
  { name: "payroll-bar-bell", iconUrl: "/icons/payroll/payroll-bar-bell.svg" },

  { name: "recruitment_alarm", iconUrl: "/icons/recruitment/alarm.svg" },
  { name: "recruitment_location", iconUrl: "/icons/recruitment/location.svg" },
  { name: "recruitment_briefcase", iconUrl: "/icons/recruitment/breifcase.svg" },
];
